<template>
  <section :class="$style.component" v-if="page.fields">
    <div :class="$style.title">
      <h1 v-html="page.fields.title" />
    </div>

    <ul :class="$style.list">
      <li
        v-for="(image, index) in page.fields.images"
        :key="`image-${index}`"
        :class="$style.item"
      >
        <div @click="openSlider(index)" :class="$style.image">
          <base-image :image="image" :sizes="sizes(image)" />
        </div>
        <!-- <base-bodytext :text="image.title" :class="$style.description" /> -->
      </li>
    </ul>

    <transition name="t-slider">
      <div v-if="sliderVisible" :class="$style.slider">
        <image-slider :media="page.fields.images" :slide="currentSlide" />
      </div>
    </transition>
  </section>
</template>

<script>
import PageService from '@/services/page'
import BaseImage from '@/components/base-image.vue'
// import BaseBodytext from '@/components/base-bodytext.vue'
import EventBus from '@/event-bus.js'
import ImageSlider from '@/components/image-slider.vue'

export default {
  components: {
    BaseImage,
    // BaseBodytext,
    ImageSlider
  },
  metaInfo() {
    return {
      title: this.page.fields ? this.page.fields.title : ''
    }
  },
  data() {
    return {
      page: {},
      sliderVisible: false,
      currentSlide: 0
    }
  },
  methods: {
    openSlider(index) {
      this.sliderVisible = true
      this.currentSlide = index
      EventBus.$emit('open-slider')
    },
    sizes(image) {
      const isPortrait = image.ratio < 1 ? true : false
      if (isPortrait) {
        return '(min-width: 1280px) 15vw, (min-width: 640px) 18vw, 100vw'
      } else {
        return '(min-width: 1280px) 30vw, (min-width: 640px) 38vw, 100vw'
      }
    }
  },
  async created() {
    this.page = await PageService.get({ id: this.$route.name })
  },
  mounted() {
    EventBus.$on('close-slider', () => {
      this.sliderVisible = false
    })
  }
}
</script>

<style lang="scss" scoped>
.t-slider-enter-active,
.t-slider-leave-active {
  transition: opacity var(--long) ease;
}

.t-slider-enter,
.t-slider-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" module>
.component {
  padding-top: calc(var(--blank-line) * 6.3);
  padding-right: var(--gutter);
  padding-left: var(--gutter);

  @media (min-width: $xxsmall) {
    padding-top: calc(var(--blank-line) * 4.45);
  }

  @media (min-width: $medium) {
    padding-top: calc(var(--blank-line) * 2.65);
  }

  @media (min-width: $large) {
    padding-top: calc(var(--blank-line) * 3);
  }
}

.title {
  @extend %ff-medium;
  @extend %fs-title;

  padding-bottom: var(--gutter);
}

// .list {}

.item {
  margin-bottom: var(--gutter);

  @media (min-width: $small) {
    display: inline-block;
    // -0.25em to remove gap introduced by inline-block
    margin-bottom: calc(var(--gutter) - 0.25em);
    height: 25vw;
    padding-right: var(--gutter);
  }

  @media (min-width: $xlarge) {
    height: 20vw;
  }
}

.image {
  @extend %cursor-pointer;

  @media (min-width: $small) {
    height: 100%;

    img {
      height: 100%;
      width: auto;
    }
  }
}

.description {
  padding-top: calc(var(--gutter) / 6);
}

.slider {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
